export const API_ENDPOINT = 'industries';
export const INDUSTRY_ENDPOINT = `${API_ENDPOINT}`;
export const INDUSTRIES_WITH_CPD_CATEGORYS_ENDPOINT = `${API_ENDPOINT}/industries-with-cpd-categorys`;
export const INDUSTRY_ROLES_ENDPOINT = (industryId) => `${API_ENDPOINT}/${(industryId)}/roles`;
export const CPD_CATEGORY_ENDPOINT = (industryId) => `${API_ENDPOINT}/${(industryId)}/areas-of-advice`;


// WEBPACK FOOTER //
// ./src/state/modules/industry/configurations/endpoints.js